module.exports = __webpack_public_path__ + "img/usb.fcee3e69.svg";